import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AppRoutingModule } from './app-routing.module';
import { AuthGuard } from './auth/guards/auth.guard';
import { AppHttpInterceptorService } from './core/utils/app.http-interceptor.service';

import { AppComponent } from './app.component';
import { reducers, metaReducers } from './core/root.reducer';
import { extModules } from '../build-specifics';
import { AuthEffects } from './auth/store/auth.effects';
import { ResidentProfileEffects } from './core/store/resident-profile/resident-profile.effects';
import { ApproverAuthEffects } from './auth/store/approver/approver-auth.effects';
import { SearcherAuthEffects } from './auth/store/searcher/searcher-auth.effects';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    GoogleTagManagerModule.forRoot({
      id: environment.googleAnalyticsTagId,
    }),
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([
      AuthEffects,
      ApproverAuthEffects,
      ResidentProfileEffects,
      SearcherAuthEffects,
    ]),
    StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
    extModules,
  ],
  providers: [
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptorService,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
